$(document).ready(function() {     

  // $(document).on("click",".checkbox-product-size-variant",function() {
  //   var variant_id = $(this).val();
  //   if ($(this).prop('checked')==true){ 
  //     $(".product-qty-variant-"+variant_id).show();
  //   }else{
  //     $(".product-qty-variant-"+variant_id).hide();
  //   }
  // });

var checkavailable = document.querySelector(".check-variant-size-picker");
if (checkavailable) { 
  $(document).on("click","#shappify_custom_add_to_cart_btn",function() {
    var product_min_quantity = $("#product-min-quantity").attr("data-product-qty-min");
    var totale_quantity = 0;
    var size_variant_checkbox = false;
    var items_array = {};
    var propertie = get_form_properties();
    $("#shappify_custom_add_to_cart_error").html("");
    var soldOutVariants = [];
    
    $(".checkbox-product-size-variant:checkbox:checked").each(function(index) {
      var item_data = {};
      size_variant_checkbox = true;
      var variant_id = $(this).val();
      var is_available = $(this).data("available");
      var variant_qty = parseInt($("#quantity-"+variant_id).val())

      if (!is_available) {
        var variant_name = $(this).data("variant-name");
        soldOutVariants.push(variant_name);
        return;
      }
      
      totale_quantity += variant_qty;
      item_data['quantity'] = variant_qty;
      item_data['id'] = parseInt(variant_id);
      item_data['properties'] = propertie;
      items_array[index] = item_data;
    });
    
    if(!size_variant_checkbox){
      $("#shappify_custom_add_to_cart_error").html("Please check the box before the size name to select the size with the minimum quantity.");
    }else if (soldOutVariants.length > 0) {
      $("#shappify_custom_add_to_cart_error").html("The following sizes are sold out: " + soldOutVariants.join(", "));
    }else if(product_min_quantity > totale_quantity){
       $("#shappify_custom_add_to_cart_error").html("This product must be ordered with a minimum of "+product_min_quantity+" items in total");
    }else{      
     $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
              items: items_array
          },
          dataType: 'json',
          success: function(response) {
              window.location.href = "/cart";
          },
          error: function(xhr, status, error) {
            $("#shappify_custom_add_to_cart_error").html("Something Went Wrong!!!");
            console.error('Error adding items to cart:', error);
          }
      }); 
    }
  });
}
  
});




function get_form_properties() {
    var params = {}
    $.each($('#add-item-form').serializeArray(), function(index, obj) {
      var propertyString = obj.name;
      if(propertyString.indexOf("properties") != -1){
         var key = propertyString.match(/properties\[(.*?)\]/)[1];
        if(key!=''){
          params[key] = obj.value;
        }
      }
    });
    return params;
}


// Set Product Qty min value set 
const quantityInputs = document.querySelectorAll('.product-qty .qty');
quantityInputs.forEach(input => {
    const minOrder = parseInt(input.dataset.min, 10) || 1;
    input.value = minOrder;

    input.addEventListener('focus', function () {
        if (parseInt(this.value, 10) === minOrder) {
            this.value = '';
        }
    });

    input.addEventListener('blur', function () {
        if (this.value === '' || parseInt(this.value, 10) < minOrder) {
            this.value = minOrder;
        }
    });
});
// Set Product Qty min value set END



document.querySelector('form#add-item-form').addEventListener('change', function(event) {
    if (event.target && event.target.type === 'file' && event.target.name === 'properties[Custom Logo]') {
        const file = event.target.files[0];

        if (file) {
            if (file.type.startsWith('image/')) {
                const reader = new FileReader();

                reader.onload = function(e) {
                    const hiddenInput = document.getElementById('product_logo');
                    const logo_img = document.getElementById('product_logo_img');
                    if (logo_img) {
                        hiddenInput.value = e.target.result;
                        logo_img.src = e.target.result;
                    }
                };

                reader.onerror = function(error) {
                    // Handle the error silently if needed, or remove this function
                };

                reader.readAsDataURL(file);
            }
        }
    }
});




jQuery(document).on('click', 'input[name="properties[Custom Logo]"]', function (event) {
    event.preventDefault();
    jQuery('.uploadcare--widget__button').trigger('click');
});


document.addEventListener('DOMContentLoaded', () => {
    setTimeout(function () {
        // Select the file input elements
        const customLogoInputs = document.querySelectorAll('div#photouploadapp input[type="file"]');
        const hiddenUploaderInputs = document.querySelectorAll('input[name="properties[Custom Logo]"]');

        if (customLogoInputs.length > 0 && hiddenUploaderInputs.length > 0) {
            // Function to copy file from one input to another
            function syncFileInput(sourceInput, targetInput) {
                if (sourceInput.files.length > 0) {
                    const dataTransfer = new DataTransfer();
                    dataTransfer.items.add(sourceInput.files[0]);
                    targetInput.files = dataTransfer.files;

                    // Show the close button
                    const closeButton = targetInput.nextElementSibling;
                    if (closeButton) {
                        closeButton.style.display = 'inline-block'; // Make the close button visible
                    }
                } else {
                    targetInput.value = '';
                }
            }

            // Function to reset file inputs
            function resetFileInput(fileInput, hiddenInput) {
                fileInput.value = ''; // Clear the visible input
                hiddenInput.value = ''; // Clear the hidden input
                const closeButton = hiddenInput.nextElementSibling;
                if (closeButton) {
                    closeButton.style.display = 'none'; // Hide the close button
                }
            }

            // Loop through each custom logo input and attach event listeners
            customLogoInputs.forEach((customLogoInput, index) => {
                const hiddenUploaderInput = hiddenUploaderInputs[index]; // Assuming corresponding inputs have the same index

                if (hiddenUploaderInput) {
                    // Create and append a close button dynamically next to hiddenUploaderInput
                    const closeButton = document.createElement('button');
                    closeButton.textContent = 'Remove Logo';
                    closeButton.type = 'button';
                    closeButton.className = 'remove_btn';
                    closeButton.style.display = 'none'; // Initially hide the button
                    closeButton.style.marginTop = '10px';
                    closeButton.style.cursor = 'pointer';

                    // Append the close button after the hidden input
                    hiddenUploaderInput.insertAdjacentElement('afterend', closeButton);

                    // Add event listener to close button
                    closeButton.addEventListener('click', () => {
                        // Trigger the action on the target element when close button is clicked
                        const targetElement = document.querySelector('.bold_options_loaded .bold_option_uploadfile > div > div > div');
                        if (targetElement) {
                            targetElement.click(); // Or you can add any other action you want here
                        }
                        resetFileInput(customLogoInput, hiddenUploaderInput);
                    });

                    // Add event listener to sync inputs on file change
                    customLogoInput.addEventListener('change', () => {
                        syncFileInput(customLogoInput, hiddenUploaderInput);
                    });

                    // Add event listener to clear inputs on input clear
                    customLogoInput.addEventListener('input', () => {
                        if (customLogoInput.value === '') {
                            resetFileInput(customLogoInput, hiddenUploaderInput);
                        }
                    });
                } else {
                    console.error(`Hidden input not found for custom logo input at index ${index}`);
                }
            });
        } else {
            console.error('One or both file input elements are not found in the DOM.');
        }
    }, 1000);
});




document.addEventListener('DOMContentLoaded', function() {
    function moveDiv() {
        const photouploadapp = document.querySelector('div#photouploadapp > div > div > div:nth-child(2)');
        const boldOptionsLoaded = document.querySelector('.bold_options_loaded .bold_option_uploadfile');

        if (photouploadapp && boldOptionsLoaded) {
            boldOptionsLoaded.appendChild(photouploadapp);
            console.log('#photouploadapp successfully moved!');
        } else {
            console.log('Elements not found yet.');
        }
    }

    // Check immediately and every 500ms
    const interval = setInterval(() => {
        moveDiv();
        if (document.querySelector('div#photouploadapp > div > div > div:nth-child(2)') && document.querySelector('.bold_options_loaded .bold_option_uploadfile')) {
            clearInterval(interval); // Stop once moved
        }
    }, 500);
});
